import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ManualRolloverSection from './ManualRolloverSection';

const ManualRolloverSectionPicker = () => {
  const { resource } = useMetaLayoutContext();

  return pick(resource, {
    [fr.relationships.noManualRollover.name]: null,
  }, <ManualRolloverSection />);
};

ManualRolloverSectionPicker.propTypes = {
};
ManualRolloverSectionPicker.defaultProps = {};

export default ManualRolloverSectionPicker;
